import {QueryFunctionContext} from "@tanstack/react-query";
import {OrderDetailsModel, OrderModel} from "./Models";
import ApiHttpClient from "@/HttpClient";

export interface OrdersListResponse {
    totalCount: number;
    totalPages: number;
    pageNumber: number;
    pageSize: number;
    items: OrderModel[]
}

export interface OrderDetailsListResponse {
    totalCount: number;
    totalPages: number;
    pageNumber: number;
    pageSize: number;
    items: OrderDetailsModel[]
}

export interface OrderResponse extends OrderModel {
}

export const fetchOrder = async ({queryKey}: QueryFunctionContext) => {
    const [, orderId] = queryKey;
    const {data, status, statusText} = await ApiHttpClient().get<OrderResponse>(`/order/${orderId}`);

    console.log(`Status ${status} ${statusText}`);
    console.log(JSON.stringify(data, null, 4));
    return data;
}

export const fetchOrdersForPreOrder = async ({queryKey}: QueryFunctionContext) => {
    const [, preOrderId, pageNumber, pageSize] = queryKey;
    const {data, status, statusText} = await ApiHttpClient().post<OrdersListResponse>(`/order/search`, {
        "advancedFilter": {
            "field": "PreOrderId",
            "operator": "eq",
            "value": Number(preOrderId)
        },
        "pageNumber": pageNumber,
        "pageSize": pageSize,
    });
    if (!data) throw new Error(`Did not receive a response, status ${status} ${statusText}`);
    return data;
}

export const fetchOrderWithDetails = async ({queryKey}: QueryFunctionContext) => {
    const [, orderId, pageNumber, pageSize] = queryKey;

    const {
        data,
        status,
        statusText
    } = await ApiHttpClient().get<OrderDetailsListResponse>(`/orderDetail/OrderId/${orderId}`, {
        params: {
            pageNumber,
            pageSize,
        }
    });

    if (!data) throw new Error(`Did not receive a response, status ${status} ${statusText}`);
    return data;
}